const config = {};
config.entity = 'd3@t4N0te!';
config.platformId = 1;
config.optType = 1;
config.optType2 = 2;
config.envMsalAzureFlag = 1; // staging - 0, production - 1
config.gameCookieName = 'icc-game-cookie';
let hostDomain = window.location.host;
let splitDomain = hostDomain.split('.');
splitDomain = splitDomain.slice(-2);
let cookieDomain = '.' + splitDomain.join('.');
config.sDomain = cookieDomain;

config.isMobile = () => {
  const mobileRegex = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
  return mobileRegex.test(navigator.userAgent);
};

config.BrowserDetect = {
  Android: function () {
    return !!navigator.userAgent.match(/Android/i);
  },
  BlackBerry: function () {
    return !!navigator.userAgent.match(/BlackBerry/i);
  },
  iOS: function () {
    return !!navigator.userAgent.match(/iPhone|iPad|iPod/i);
  },
  iPAD: function () {
    return !!navigator.userAgent.match(/iPad/i);
  },
  Windows: function () {
    return !!navigator.userAgent.match(/Windows/i);
  },
  Windows_surface: function () {
    return !(!navigator.userAgent.match(/Trident/i) || !navigator.userAgent.match(/Tablet/i));
  },
  any: function () {
    return (
      config.BrowserDetect.Android() ||
      config.BrowserDetect.BlackBerry() ||
      config.BrowserDetect.iOS() ||
      config.BrowserDetect.Windows()
    );
  },
  ie9: function () {
    return !!navigator.userAgent.match(/MSIE 9.0/i);
  },
  ie10: function () {
    return !!navigator.userAgent.match(/MSIE 10.0/i);
  },
  ie11: function () {
    return !!navigator.userAgent.match(/Trident.*rv[ :]*11\./);
  },
  ie: function () {
    return config.BrowserDetect.ie9() || config.BrowserDetect.ie10() || config.BrowserDetect.ie11();
  },
  FF: function () {
    return typeof InstallTrigger !== 'undefined';
  },
  safari: function () {
    var ua = navigator.userAgent.toLowerCase();
    if (ua.indexOf('safari') !== -1) {
      if (ua.indexOf('crios') > -1) {
        return false; // Chrome
      } else {
        return true; // Safari
      }
    }
  }
};
config.skillObj = [
  // {
  //   id: 4,
  //   skillName_fullName: 'classic_createteam_wicketkeeper',
  //   skillName_shortName: 'classic_createteam_wk',
  //   skill_icon: 'ghgh',
  //   skill_val: 'WK'
  // },
  {
    id: 1,
    skillName_fullName: 'classic_createteam_batters',
    skillName_shortName: 'classic_createteam_bat',
    skill_icon: 'lms-bat',
    skill_val: 'BAT'
  },
  {
    id: 2,
    skillName_fullName: 'classic_createteam_bowler',
    skillName_shortName: 'classic_createteam_bowl',
    skill_icon: 'lms-ball',
    skill_val: 'BOWL'
  },
  {
    id: 3,
    skillName_fullName: 'classic_createteam_allrounder',
    skillName_shortName: 'classic_createteam_ar',
    skill_icon: 'lms-all-rounder',
    skill_val: 'AR'
  }
];

config.leaderboardHeader = [
  {
    title: 'Rank',
    transKey: 'leaderboard_rank',
    keys: ['Trend', 'rank'],
    type: 'trendWithText',
    cls: 'rank'
  },
  {
    title: 'Name',
    transKey: 'leaderboard_name',
    keys: ['TeamName'],
    type: 'text',
    cls: 'name'
  },

  {
    title: 'Points',
    transKey: 'leaderboard_points',
    keys: ['achievements'],
    type: 'achievements',
    cls: 'points'
  }
];

config.sponsorList = [
  {
    groupTitleKey: 'sponsor_title_1',
    images: [
      {
        name: 'Emirates',
        image: 'emrates',
        link: 'https://www.emirates.com/english/book/'
      },
      {
        name: 'Aramco',
        image: 'aramco',
        link: 'https://www.aramco.com/'
      },
      {
        name: 'DP World',
        image: 'dp-wrold',
        link: 'https://www.dpworld.com/'
      }
    ]
  },
  {
    groupTitleKey: 'sponsor_title_2',
    images: [
      {
        name: 'Coca Cola',
        image: 'cocacola',
        link: 'https://www.coca-colacompany.com/'
      },
      {
        name: 'IndusInd Bank',
        image: 'induslnd-bank',
        link: 'https://www.indusind.com/in/en/personal.html'
      }
    ]
  },
  {
    groupTitleKey: 'sponsor_title_3',
    images: [
      {
        name: 'Royal Stag',
        image: 'royal-stag',
        link: 'https://www.pernod-ricard.com/en/brands/royal-stag'
      },
      {
        name: 'Near',
        image: 'xnear',
        link: 'https://near.org/'
      },
      {
        name: 'Fan Craze',
        image: 'fancraze',
        link: 'https://www.fancraze.com/'
      }
    ]
  },
  {
    groupTitleKey: 'sponsor_title_4',
    images: [
      {
        name: 'Cricket4Good',
        image: 'cricket4good',
        link: 'https://www.icc-cricket.com/about/the-icc/cricket-for-good'
      }
    ]
  }
];

config.gameCards = [
  {
    titleKey: 'homecard_title_1',
    descriptionKey: 'homecard_description_1',
    // showButton: false,
    buttonText: 'homecard_button_1',
    thumbName: 'lms',
    path: config.SEASON_BASE_URL + '/home'
  },
  {
    titleKey: 'homecard_title_2',
    descriptionKey: 'homecard_description_2',
    // showButton: false,
    thumbName: 'predictor',
    buttonText: 'homecard_button_2',
    path: config.DAILY_BASE_URL + '/home'
  }
];

config.otherGameCards = [
  {
    title: 'PREDICTOR',
    subTitle: 'Before the toss, before the play make your predictions now!',
    // imageSrc: 'game-1',
    buttonText: 'Predict Now',
    gameCardType: 'predictor',
    url: `${process.env.REDIRECT_PREDICTOR_URL}`
  }
];

config.matchFantasyLBTab = [
  { id: 1, objKey: 'matches_matches_toggle', skill_val: 'MATCHES' },
  { id: 2, objKey: 'matches_overall_toggle', skill_val: 'OVERALL' }
];

config.skillShortName = ['WK', 'BAT', 'BOWL', 'AR'];

export default config;
